<template>
  <v-card width="375" min-height="200" flat class="mx-auto d-flex flex-column justify-center">

    <img src="@/assets/alert-circle-outline.svg" class="checkmark"/>
    
    <v-card-title class="resultTitle justify-center">
      {{ $t('payment_failed') }}
    </v-card-title>

    <div class="resultSubTitle center">{{ error }}</div>

    <v-card-actions class="mt-10 mb-10 pa-0">
      <ConfirmButton
        @click="postAbortMessage"
        class="icon-button">
        {{$t('continue')}}
        <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
      </ConfirmButton>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { VCard, VCardTitle, VCardActions } from 'vuetify/lib'
  import ConfirmButton from '@/components/ConfirmButton'
  import postMessageMixin from '@/mixins/postMessageMixin'

  export default {
    name: 'Error',
    mixins: [postMessageMixin],
    components: { VCard, VCardTitle, VCardActions, ConfirmButton },
    props: {
      error: {
        type: String,
        default: ''
      },
      errorCode: {
        type: String,
        default: ''
      },
      origin: {
        type: String,
        default: ''
      },
      params: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      postAbortMessage: function () {
        this.postMessageToParent({ messageType: 'abort', resultCode: this.errorCode, error: this.error }, this.params, this.origin)
      }
    }
  }
</script>